import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import TDSMonthlySummary from './TDSMonthlySummary';
import TDSDeducteeDetails from './TDSDeducteeDetails';

const TDS_TABS = [
  { label: 'Monthly Summary', value: 0 },
  { label: 'Deductee Details', value: 1 }
];

export default function TDS() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        sx={{
          mb: 2,
          borderBottom: '1px solid #eaedf1',
          '& .MuiTab-root': {
            minHeight: 40,
            py: 1,
            textTransform: 'none',
            fontSize: 13,
            fontWeight: 500
          },
          '& .Mui-selected': { color: '#0d4689', fontWeight: 700 },
          '& .MuiTabs-indicator': { backgroundColor: '#4fbbc8' }
        }}
      >
        {TDS_TABS.map((t) => (
          <Tab key={t.value} label={t.label} value={t.value} />
        ))}
      </Tabs>

      {activeTab === 0 && <TDSMonthlySummary />}
      {activeTab === 1 && <TDSDeducteeDetails />}
    </Box>
  );
}
